export interface PokedexVariantQueryParams {
  form: string;
  type: string;
}

export const pokedexVariantQueryParams = (form: string, type: string): PokedexVariantQueryParams | null =>
  form || type !== 'normal' ? { form, type } : null;
